export const BARCODE_DAGDEELNEMER = 1140010000009;
